import { Vector3 } from 'three';

export class PointsPair {
  public startPoint: Vector3;
  public endPoint: Vector3;
  public distance: number;

  public constructor(startPoint: Vector3, endPoint: Vector3, distance: number) {
    this.startPoint = startPoint;
    this.endPoint = endPoint;
    this.distance = distance;
  }
}
